import {
  FormGridItem,
  type FormGridItemProps,
  TextField,
  type TextFieldProps,
  useZipCodeValidator,
} from '@ace-clublabs/shared-component-library';
import { defaultInputProps, getRequiredFieldSx } from '../utils';

export interface ZipCodeFieldProps {
  value?: string;
  onChange: (value: string) => void;
  required?: boolean;
  fieldProps?: Partial<TextFieldProps<'zip-code'>>;
  validatorProps?: Parameters<typeof useZipCodeValidator>[0];
  gridItemProps?: Partial<FormGridItemProps>;
}

export const ZipCodeField: React.FC<ZipCodeFieldProps> = ({
  value,
  onChange,
  required = false,
  fieldProps,
  validatorProps,
  gridItemProps,
}) => {
  const label = 'Zip code';
  const validator = useZipCodeValidator({
    label,
    required,
    ...validatorProps,
  });

  return (
    <FormGridItem
      size={{ xs: 12, lg: 6 }}
      {...gridItemProps}
      sx={getRequiredFieldSx(required)}
    >
      <TextField
        for='zip-code'
        label={label}
        {...defaultInputProps}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        validator={validator}
        data-testid='zipCode'
        slotProps={{
          ...defaultInputProps.slotProps,
          htmlInput: { inputMode: 'numeric', pattern: '[0-9]*' },
        }}
        {...fieldProps}
      />
    </FormGridItem>
  );
};
